import React from "react";
import { Link } from "react-router-dom";

const cards = [
  { 
    title: "Room Booking", 
    description: "Manage room bookings.", 
    icon: "🛌", 
    link: "/hotels/bookingpage",
    component: "BookingPage" 
  },
  { 
    title: "Booking List", 
    description: "View all bookings.", 
    icon: "📋", 
    link: "/hotels/bookinglistpage",
    component: "BookingListPage" 
  },
  { 
    title: "Room List", 
    description: "View all rooms.", 
    icon: "🚪", 
    link: "/hotels/roomlistpage",
    component: "RoomListPage" 
  },
  { 
    title: "Room Status", 
    description: "Track room availability.", 
    icon: "📊", 
    link: "/hotels/roomstatuspage",
    component: "RoomStatusPage" 
  },
  { 
    title: "Amenities", 
    description: "Manage amenities.", 
    icon: "🏊", 
    link: "/hotels/amenitieslistpage",
    component: "AmenitiesListPage" 
  },
  { 
    title: "Housekeeping", 
    description: "Track housekeeping tasks.", 
    icon: "🧹", 
    link: "/hotels/housekeepingpage",
    component: "HousekeepingPage" 
  },
  { 
    title: "Promotions", 
    description: "Create and manage promotions.", 
    icon: "🏷️", 
    link: "/hotels/promotionspage",
    component: "PromotionsPage" 
  },
  { 
    title: "Guest List", 
    description: "Track guest information.", 
    icon: "👤", 
    link: "/hotels/guestlistpage",
    component: "GuestListPage" 
  },
];

const HotelDashboardCards = () => (
  <div className="hotel-dashboard">
    <h1>Hotel Management Dashboard</h1>
    <div className="card-grid">
      {cards.map((card) => (
        <Link 
          key={card.title} 
          to={card.link} 
          className="card"
          aria-label={`Navigate to ${card.title}`}
        >
          <div className="card-icon" role="img">
            {card.icon}
          </div>
          <h3 className="card-title">{card.title}</h3>
          <p className="card-description">{card.description}</p>
          <div className="arrow-indicator" aria-hidden="true">→</div>
        </Link>
      ))}
    </div>
  </div>
);

export default HotelDashboardCards;